import {immerable} from "immer";
import ExtractionDataDto from "@/models/interfaces/dtos/extraction/extraction-data-dto.ts";
import ProjectMeasures from "@/pages/takeoff/context/project-measure/models/project-measures.ts";
import MeasureType from "@/pages/takeoff/context/project-measure/models/measure-type.ts";
import ExtractionNodeElement from "./interfaces/extraction-node-element.ts";
import ExtractionSheetTree from "./extraction-sheet-tree.ts";
import ExtractionSheetLeafNode from "./extraction-sheet-leaf-node.ts";
import ExtractionSheetArticleNode from "./extraction-sheet-article-node.ts";
import ProjectIndicatorsDto from "@/models/interfaces/dtos/indicators/project-indicators-dto.ts";

class ProjectExtractionSheets {
    [immerable] = true;
    
    sheets: ExtractionSheetTree[];

    isDirty = false;
    
    constructor(sheets?: ExtractionSheetTree[]) {
        this.sheets = sheets ?? [];
    }

    static fromDto(dto: ExtractionDataDto[], projectMeasures: ProjectMeasures, measureTypes: MeasureType[], projectIndicatorsData?: ProjectIndicatorsDto): ProjectExtractionSheets {
        const sheets = dto.map(sheetDto => ExtractionSheetTree.fromDto(sheetDto, projectMeasures, measureTypes, projectIndicatorsData));
        return new ProjectExtractionSheets(sheets);
    }
    
    setIsDirty(dirty: boolean) {
        this.isDirty = dirty;
    }
    
    addSheet(name: string) {
        const sheet = new ExtractionSheetTree(name);
        this.sheets.push(sheet);
    }

    getSheetById(sheetId: string): ExtractionSheetTree | undefined {
        return this.sheets.find(sheet => sheet.id === sheetId);
    }
    
    removeSheet(sheetId: string) {
        this.sheets = this.sheets.filter(sheet => sheet.id !== sheetId);
    }
    

    getNodeById(id: string): ExtractionSheetLeafNode | undefined {
        const found = this.findElementById(id);
        if (found instanceof ExtractionSheetLeafNode) {
            return found;
        }
        return undefined;
    }

    getArticleById(id: string): ExtractionSheetArticleNode | undefined {
        const found = this.findElementById(id);
        if (found instanceof ExtractionSheetArticleNode) {
            return found;
        }
        return undefined;
    }
    
    /* Helpers */

    findElementById(id: string): ExtractionNodeElement | undefined {
        for (let i = 0; i < this.sheets.length; i += 1) {
            const sheet = this.sheets[i];
            const found = sheet.findElementById(id);
            if (found) {
                return found;
            }
        }
        return undefined;
    }
}

export default ProjectExtractionSheets;